import { VStack, HStack } from '@chakra-ui/react';
import { t } from 'i18next';
import { SearchInput } from 'Molecules/index.ts';
import { BodyText } from 'Tokens/index.ts';
import React from 'react';
import { CompanyStructureAddMenu } from './CompanyStructureAddMenu.tsx';
import { CompanyStructureHeaderActions } from './CompanyStructureHeaderActions.tsx';
import { BusinessUnitsSortingType } from 'containers/Assessments/pieces/Assessment.hooks.ts';

export const CompanyStructureHeader = ({
  setSelectedParentGroup,
  onCreateBU,
  onCreateGroup,
  query,
  setQuery,
  businessUnitsSorting,
}: {
  setSelectedParentGroup: (parent: string | undefined) => void;
  onCreateBU: () => void;
  onCreateGroup: () => void;
  query: string;
  setQuery: (query: string) => void;
  businessUnitsSorting: BusinessUnitsSortingType;
}) => {
  return (
    <VStack spacing="16px" height="100%" width="100%" flex={0}>
      <HStack justifyContent="space-between" width="100%" paddingTop="12px" paddingX="16px">
        <BodyText fontSize="14px" fontWeight="600" lineHeight="20px">
          {t('bUnits:title')}
        </BodyText>
        <CompanyStructureAddMenu
          onCreateBU={onCreateBU}
          onCreateGroup={onCreateGroup}
          setSelectedParentGroup={setSelectedParentGroup}
        />
      </HStack>
      <HStack paddingX="16px" width="100%">
        <SearchInput
          size="sm"
          search={query}
          setSearch={setQuery}
          width="100%"
          placeholder={t('bUnits:search.placeholder')}
        />
        <CompanyStructureHeaderActions businessUnitsSorting={businessUnitsSorting} />
      </HStack>
    </VStack>
  );
};
